// src/pages/BundeslandHamburg.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { hamburg } from "../components/states/hamburg";

export default function BundeslandHamburg() {
  return <BundeslandPage data={hamburg} />;
}

